// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","3930":"164f4fb6","4316":"ad2866b8","5033":"2f0b94e8"}[chunkId] || chunkId) + "." + {"501":"03463a0c38307e88","747":"c06540d122708e85","3127":"5ef1c9f48a8ff6b8","3930":"570788815820a4c9","4316":"bdc65d4186c0e901","5033":"06bb48dd7f7c3e62","9715":"e0702666c2f77263"}[chunkId] + ".js";
};